import * as React from "react";
import PropTypes from "prop-types";
import DisplayCard from "./DisplayCard";
import { nanoid } from "nanoid";

function returnAuthorSlugs(authorCollection) {
  let k = null;
  let v = null;
  let results = [];

  authorCollection.forEach((author) => {
    k = author.frontmatter.name;
    v = author.fields.slug;
    results[k] = v;
  });
  return results;
}

function returnAuthorSlug(name, slugs = []) {
  if (slugs[name]) {
    return slugs[name];
  } else {
    return "";
  }
}

const BlogRoll = ({
  posts,
  authors,
  displayType = "past",
  button = "Read",
}) => {
  const authorSlugs = returnAuthorSlugs(authors);

  let now = new Date().getTime();
  let filteredPosts = posts;

  switch (displayType) {
    default:
      break;

    case "past":
      filteredPosts = posts.filter((posts) => {
        let appearanceTime = new Date(
          posts.node.frontmatter.meta.sortDate
        ).getTime();

        return appearanceTime < now;
      });
      break;
    case "future":
      filteredPosts = posts.filter((posts) => {
        let appearanceTime = new Date(
          posts.node.frontmatter.meta.sortDate
        ).getTime();

        return appearanceTime > now;
      });
      break;
    case "all":
      // do not filter anything
      break;
  }

  return (
    <div className="columns is-multiline">
      {filteredPosts &&
        filteredPosts.map(({ node: post }) => (
          <React.Fragment key={nanoid()}>
            <div className="is-parent column is-6" key={post.id}>
              <DisplayCard
                image={post.frontmatter.image}
                title={post.frontmatter.title}
                slug={post.fields.slug}
                category={post.frontmatter.category}
                date={post.frontmatter.meta.creationDate}
                excerpt={
                  post.frontmatter.summary
                    ? post.frontmatter.summary
                    : post.excerpt
                }
                showExcerpt={true}
                showTags={true}
                featured={post.frontmatter.featured}
                tags={post.frontmatter.tags}
                buttonText={button}
                relatedPersonSlug={returnAuthorSlug(
                  post.frontmatter.meta.author,
                  authorSlugs
                )}
                relatedPerson={post.frontmatter.meta.author}
              />
            </div>
          </React.Fragment>
        ))}
    </div>
  );
};

BlogRoll.propTypes = {
  posts: PropTypes.array,
};

export default BlogRoll;
